 

<div class="dialog-container">
    <div class="DialogElements">
        <div class="Dialogtitle">
              {{dialogProps.title}}
           
        </div>
        <div class="Dialogcontent">
            <div class="AllDataProvidedUpToThisPointWillBeLostIfYouCancelNowYouWillNeedToStartTheSignInProcessFromTheBeginning" style="align-self: stretch; color: #444746; font-size: 12px; font-family: Roboto; font-weight: 400; line-height: 19.92px; letter-spacing: 0.40px; word-wrap: break-word">{{dialogProps.message}}</div>
        </div>
        <div class="Dialogactions" >
          
            <button   (click)="close()"   mat-stroked-button mat-button class="button-stepper-back">
                GO BACK
                <mat-icon>arrow_left_alt</mat-icon>
              </button>
              <button  (click)="goBack()"    mat-stroked-button mat-button class="button-stepper-danger">
               CANCEL PROCESS
              </button>
        </div>
    </div>
</div>